import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/Icon/Icon';
import './SDUI.scss';

/**
 * Suggestion - Displays AI suggestions with optional action buttons
 * 
 * @param {string} title - Suggestion title
 * @param {string} text - Suggestion message
 * @param {Array} options - Optional action buttons
 * @param {Function} onOptionClick - Callback when option is clicked
 */
export const Suggestion = ({ title = 'Suggestion', text, options, onOptionClick }) => {
  const handleClick = (option) => {
    if (onOptionClick) {
      onOptionClick(option);
    }
  };

  return (
    <div className='sdui-suggestion'>
      <div className='suggestion-header'>
        <Icon name='Bell' size='sm' />
        <span className='title'>{title}</span>
      </div>
      <div className='suggestion-content'>
        <p>{text}</p>
        {options && options.length > 0 && (
          <div className='suggestion-options'>
            {options.map((option, idx) => (
              <button
                key={idx}
                className='option-button'
                onClick={() => handleClick(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

Suggestion.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      field: PropTypes.string,
      value: PropTypes.any,
    })
  ),
  onOptionClick: PropTypes.func,
};

export default Suggestion;
